<template>
    <div id="read">
        <div>
            <el-card>
                <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="addRecharge">添加设置</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            label="序号"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="key"
                            label="分钟">
                    </el-table-column>
                    <el-table-column
                            prop="coin"
                            :label="this.$store.state.name">
                    </el-table-column>
                    <el-table-column
                            width="150"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="warning" plain size="small" @click="edit(scope.row.id)">
                                修改
                            </el-button>
                            <el-button type="danger" plain size="small" @click="remove(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="fromTitle"
                       :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'90%':'50%'"
                       :visible.sync="visible">

                <el-form ref="form"
                         :label-width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'100px':'150px'"
                         size="small">
                    <el-form-item label="分钟"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-input v-model="form.key"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                    <el-form-item :label="this.$store.state.name"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'">
                        <el-input v-model="form.coin"
                                  :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':'minWidth'"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        name: "read",
        data() {
            return {
                form: {
                    key: '',
                    coin: '',
                },
                tableData: [],
                visible: false,
                fromTitle: '',
                id: '',
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.post('admin/daily_read_rule/index', {}).then((res) => {
                    let obj = res.data;
                    let arr = [];
                    for (let key in obj) {
                        arr.push(obj[key])
                    }
                    this.tableData = arr;
                });
            },

            dialogClose() {
                this.visible = false
            },
            addRecharge() {
                this.form = {
                    key: '',
                    coin: '',
                };
                this.id = '';
                this.fromTitle = '新增';
                this.visible = true
            },
            edit(id) {
                this.fromTitle = '修改';
                this.id = id;
                this.$axios.get('admin/daily_read_rule/' + this.id, '').then((res) => {
                    this.visible = true;
                    this.form = res.data;
                });
            },
            dialogAffirm() {
                if (this.id) {
                    // 编辑
                    this.$axios.put('admin/daily_read_rule/' + this.id, this.form).then((res) => {
                        this.$message.success('成功');
                        this.getData();
                        this.visible = false
                    });
                } else {
                    // 添加
                    this.$axios.post('admin/daily_read_rule', this.form).then((res) => {
                        this.$message.success('成功');
                        this.getData();
                        this.visible = false
                    });
                }
            },
            remove(id) {
                this.$confirm('确定要进行操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.del('admin/daily_read_rule/' + id, '').then((res) => {
                        this.$message.success('删除成功!');
                        this.getData();
                    });
                }).catch(() => {

                });
            }
        }
    }
</script>

<style scoped>

</style>